import { getFrameworkDataSchemasClient } from 'framework-data-schema-resolvers';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { captureException } from 'messaging-management-lib/logging/raven';
import useHasAllGates from 'messaging-management-lib/user/hooks/useHasAllGates';
import makeGlobalStateHook from 'messaging-management-lib/data/makeGlobalStateHook';
const usePropertyDefinitionState = makeGlobalStateHook();
export default function useGetCustomProperties({
  objectTypeId,
  requiredGates
}) {
  const hasAllGates = useHasAllGates();
  const hasRequiredGates = useMemo(() => {
    return hasAllGates(requiredGates);
  }, [requiredGates, hasAllGates]);
  const [customProperties, setCustomProperties] = usePropertyDefinitionState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const loadCustomProperties = useCallback(({
    refetch
  } = {
    refetch: false
  }) => {
    if (!hasRequiredGates) return;
    setIsLoading(true);
    setError(null);
    return getFrameworkDataSchemasClient().then(client => {
      return client.properties.get({
        frameworkTypeIdentifier: objectTypeId,
        refetch
      });
    }).then(properties => {
      const customProps = properties.filter(prop => !prop.property.hubspotDefined);
      setCustomProperties(customProps);
      setIsLoading(false);
    }).catch(err => {
      setError(err);
      setIsLoading(false);
      captureException(err, {
        extra: {
          location: 'useGetCustomProperties'
        }
      });
    });
  }, [hasRequiredGates, objectTypeId, setCustomProperties]);
  useEffect(() => {
    void loadCustomProperties();
  }, [loadCustomProperties]);
  return {
    customProperties,
    isLoadingCustomProperties: isLoading,
    customPropertiesError: error,
    loadCustomProperties
  };
}